import { useCallback } from 'react'
import { MAX_MESSAGE_ATTACHMENTS } from './aiAskBarLayoutConstants'
import { useAiAskBarFileInputHandler } from './useAiAskBarFileInputHandler'
import { useAiAskBarLibraryAttach } from './useAiAskBarLibraryAttach'
import { useComposerAttachmentUpload } from './useComposerAttachmentUpload'
import { useRemoveAttachment } from './useRemoveAttachment'

export function useAiAskBarAttachmentActions({
  attachments,
  attachmentsRef,
  fileInputRef,
  setAttachments,
  setDocumentsPickerOpen,
  revokePreviewUrls,
  uploads,
  chat,
}) {
  const startUpload = useComposerAttachmentUpload({ setAttachments, uploads, chat })
  const library = useAiAskBarLibraryAttach({ attachmentsRef, setAttachments })
  const handleOpenFilePicker = useCallback(() => {
    if (attachments.length >= MAX_MESSAGE_ATTACHMENTS) return
    fileInputRef.current?.click()
  }, [attachments.length, fileInputRef])

  const handleOpenDocumentsPicker = useCallback(() => {
    if (attachments.length >= MAX_MESSAGE_ATTACHMENTS) return
    setDocumentsPickerOpen(true)
  }, [attachments.length, setDocumentsPickerOpen])

  const handleRemoveAttachment = useRemoveAttachment({ setAttachments, uploads })

  const handleFileInputChange = useAiAskBarFileInputHandler({ attachmentsRef, setAttachments, startUpload })

  return {
    handleOpenFilePicker,
    handleOpenDocumentsPicker,
    ...library,
    handleRemoveAttachment,
    handleFileInputChange,
    revokePreviewUrls,
  }
}
